import { Component, computed, inject } from '@angular/core';
import { ToastService } from '@services/toast.service';

@Component({
  imports: [],
  selector: 'app-toast',
  styleUrl: './toast.component.scss',
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  private toastService = inject(ToastService);
  private currentToast = this.toastService.getCurrentToast();
  protected message = computed(() => this.currentToast()?.message || '');
  protected show = computed(() => this.currentToast()?.status === 'show');
  protected title = computed(() => this.currentToast()?.title || '');
  protected type = computed(() => this.currentToast()?.type || 'info');

  protected close(): void {
    this.toastService.hideCurrentToast();
  }
}
